import { v4 as uuidv4 } from 'uuid';

import storeProvider from '../storeProvider';
import {
  addFlashMessage as addFlashMessageAction,
  removeFlashMessage as removeFlashMessageAction,
} from '../actions/App';

export const addFlashMessage = (message) => {
  const store = storeProvider.getStore();

  let { duration, type } = message;
  if (!type) {
    type = 'info';
  }

  if (duration === undefined) {
    switch (type) {
      case 'info':
      case 'success':
      case 'warning':
        duration = 3000;
        break;
      case 'danger':
        duration = 8000;
        break;
      case 'download':
        duration = 600000;
        break;
      case 'update':
        duration = 3600000 * 12;
        break;

      default:
        duration = 3000;
    }
  } else {
    duration = parseInt(duration);
  }

  const id = uuidv4();
  store.dispatch(addFlashMessageAction({
    id: message.id || id,
    ...message,
  }));

  if (duration > 0) {
    setTimeout(() => {
      store.dispatch(removeFlashMessageAction(id));
    }, duration);
  }
};

export const removeFlashMessage = (messageId) => {
  const store = storeProvider.getStore();
  store.dispatch(removeFlashMessageAction(messageId));
};

export const addFlashErrorMessage = (intl) => {
  addFlashMessage({
    type: 'danger',
    text: intl.formatMessage(
      {
        defaultMessage: '<strong>Something went wrong.</strong>{br}Please try again or contact us.',
      },
      {
        br: '\n',
      },
    ),
  });
};
